import React, { useState, useEffect } from 'react';

const sliderImages = [
  {
    id: 1,
    url: '/college-building.jpeg',
    title: 'Paramananda College of Nursing',
    description: 'Excellence | Compassion | Care — Bengaluru, Karnataka',
  },
  {
    id: 2,
    url: '/nursing-classroom-banner.jpg',
    title: 'Modern Classrooms',
    description: 'Interactive learning environments for future healthcare leaders',
  },
  {
    id: 3,
    url: '/nursing-lab-banner.jpg',
    title: 'Advanced Clinical Labs',
    description: 'State-of-the-art simulation labs for hands-on practical training',
  },
  {
    id: 4,
    url: '/nursing-clinical-banner.jpg',
    title: 'Expert Teaching & Mentorship',
    description: 'Learn from highly qualified professionals in real-world scenarios',
  },
];

function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);

  return (
    <section id="hero" className="hero">
      <div className="hero-container">
        {/* Full-width Slider + Stats */}
        <div className="hero-main">
          {/* Slider */}
          <div className="slider-container">
            {sliderImages.map((slide, index) => (
              <div key={slide.id} className={`slider-slide ${index === currentSlide ? 'active' : ''}`}>
                <img 
                  src={slide.url} 
                  alt={slide.title} 
                  className="slider-image" 
                  style={slide.id === 1 ? { objectFit: 'contain', backgroundColor: 'var(--primary-dark)' } : {}}
                />
                <div className="slider-content">
                  <span className="slider-badge">🌟 NAAC A++ Accredited</span>
                  <h2 className="slider-title">{slide.title}</h2>
                  <p className="slider-description">{slide.description}</p>
                  <div className="slider-buttons">
                    <button className="btn btn-primary" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>Apply Now</button>
                    <a href="/Paramananda_College_of_Nursing_Prospectus.pdf" target="_blank" rel="noopener noreferrer" className="btn btn-secondary" style={{ textDecoration: 'none' }}>
                      📄 Download Prospectus
                    </a>
                  </div>
                </div>
              </div>
            ))}
            
            <button className="slider-control prev" onClick={prevSlide}>‹</button>
            <button className="slider-control next" onClick={nextSlide}>›</button>
            
            <div className="slider-dots">
              {sliderImages.map((_, index) => (
                <button
                  key={index}
                  className={`slider-dot ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>
          </div>

          {/* Stats Row (Below Slider) */}
          <div className="stats-row">
            <div className="stat-card">
              <span className="stat-icon">🎓</span>
              <span className="stat-value">5000+</span>
              <span className="stat-label">Graduates</span>
            </div>
            <div className="stat-card">
              <span className="stat-icon">💼</span>
              <span className="stat-value">98%</span>
              <span className="stat-label">Placement</span>
            </div>
            <div className="stat-card">
              <span className="stat-icon">👨‍🏫</span>
              <span className="stat-value">50+</span>
              <span className="stat-label">Faculty</span>
            </div>
            <div className="stat-card">
              <span className="stat-icon">🏆</span>
              <span className="stat-value">25+</span>
              <span className="stat-label">Years</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;